import { render, staticRenderFns } from "./input-postcode.vue?vue&type=template&id=5ddff911"
import script from "./input-postcode.vue?vue&type=script&lang=js"
export * from "./input-postcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackreeve/projects/logshed/wp-content/themes/logshed/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ddff911')) {
      api.createRecord('5ddff911', component.options)
    } else {
      api.reload('5ddff911', component.options)
    }
    module.hot.accept("./input-postcode.vue?vue&type=template&id=5ddff911", function () {
      api.rerender('5ddff911', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/input-postcode.vue"
export default component.exports